
const TableNameOutputLine = 'appl\\model\\entity\\OutputLine';

export default TableNameOutputLine;
